import { ONE_HOUR, ONE_MINUTE, ONE_YEAR } from '../../tools/utils/timeUtils';
export var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
export var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
export var SESSION_COOKIE_EXPIRATION_DELAY = ONE_YEAR;
export var SESSION_NOT_TRACKED = '0';
/**
 * @internal
 */

export var SessionPersistence = {
  COOKIE: 'cookie',
  LOCAL_STORAGE: 'local-storage'
};